// Pillar: show drawer briefly after add-to-cart, then auto-close
(function () {
  const AUTO_CLOSE_MS = 2500; // change to 1200 or 2500 if you want

  function closeDrawer() {
    const drawer =
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer') ||
      document.querySelector('.drawer');

    // Click the close button if it exists
    const closeBtn =
      (drawer && drawer.querySelector('[aria-label="Close"]')) ||
      (drawer && drawer.querySelector('.drawer__close')) ||
      document.querySelector('#CartDrawer [aria-label="Close"]') ||
      document.querySelector('#CartDrawer .drawer__close');

    if (closeBtn) closeBtn.click();

    // Fallback: remove common open states
    if (drawer) {
      drawer.removeAttribute('open');
      drawer.classList.remove('is-open', 'active', 'open');
    }

    document.body.classList.remove('drawer-open', 'cart-drawer-open', 'overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
  }

  function scheduleClose() {
    clearTimeout(window.__cartDrawerCloseTimer);
    window.__cartDrawerCloseTimer = setTimeout(closeDrawer, AUTO_CLOSE_MS);
  }

  // After add-to-cart form submits, let drawer open then close shortly after
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;
      setTimeout(scheduleClose, 650);
    },
    true
  );

  // If theme/app emits events, also close
  document.addEventListener('cart:open', scheduleClose, true);
  document.addEventListener('cart:updated', scheduleClose, true);
})();